import { styled } from '@stitches/react';

import { Button } from '../../../Button/Button';
import { ButtonCopy } from '../../../Button/ButtonCopy';
import { InsertCompound } from '../InsertCompound/InsertCompound';
import { CompoundEditorActions } from '../../hooks/useCompoundEditor';

const ButtonContainer = styled('div', {
  display: 'flex',
  gap: '$4',
});

interface ToolbarProps {
  smiles?: string;
  context?: React.ReactNode;
  actions: CompoundEditorActions;
  isReaction?: boolean;
}

export function Toolbar(props: ToolbarProps) {
  const { smiles, context, actions, isReaction = false } = props;

  return (
    <ButtonContainer>
      <InsertCompound
        onPickAtom={actions.onFragmentAtomMode}
        onPickBond={actions.onFragmentBondMode}
        setMols={actions.setMols}
        isReaction={isReaction}
      />
      <Button
        weight="minimal"
        text="Clean up"
        icon="auto_fix_normal"
        onClick={actions.redraw}
        size="small"
        disabled={!smiles}
      />
      <Button weight="minimal" text="Reset" icon="delete" onClick={actions.clear} size="small" disabled={!smiles} />
      <ButtonCopy weight="minimal" text="Copy SMILES" copy={smiles ?? ''} disabled={!smiles} size="small" />

      {context ? <div>{context}</div> : null}
    </ButtonContainer>
  );
}
